import "./autobiography.scss";
import React from "react";
import { PhotoColumn } from "../../components/photo-column";
import baba1 from '../../assets/photos/baba/yakub-baba-1.jpg';
import baba1Mini from '../../assets/photos/baba/yakub-baba-1-mini.jpg';
import baba2 from '../../assets/photos/baba/yakub-baba-2.jpg';
import baba2Mini from '../../assets/photos/baba/yakub-baba-2-mini.jpg';
import MurtazaEfendi from '../../assets/photos/portraits/murtaza-efendi.jpg';
import babaFoto from '../../assets/photos/portraits/baba-foto.jpg';
import mehmetZahidKotku from '../../assets/photos/portraits/mehmet-zahid-kotku-mini.jpg';
import ibrahimSubasi from '../../assets/photos/portraits/ibrahim-subasi-mini.jpg';
import hilafetMerasimiHuzurda from '../../assets/photos/hakkimizda/hilafet-merasimi-huzura-gelirken.jpg';
import hilafetMerasimi from '../../assets/photos/hakkimizda/yakub-baba-hilafet-merasimi.jpg';
import semazenbasiSikkeMerasami from '../../assets/photos/hakkimizda/selman-dede-sema-sikkesi.jpg';
import hzPireNiyaz from '../../assets/photos/hakkimizda/hz-pire-niyaz.jpg';
import babaTaciSerifNiyaz from '../../assets/photos/hakkimizda/baba-taci-serif-niyaz.jpg';

interface AutobiographyProps {

}
interface AutobiographyState {
    Change: boolean;
}

class Autobiography extends React.Component<AutobiographyProps, AutobiographyState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    getItems = () => {
    }

    render() {
        return (
            <section className="autobiograhy-section">
                <h3 className="auto-title">ALİ YAKUB BABACAN <br />(30 Nisan 1946 - &#8734;)</h3>

                <div style={{ display: "flex" }}>
                    <PhotoColumn
                        imageSource={baba1}
                        imageTitle="Ali Yakub Babacan"
                        imageSourceList={[{ src: baba1Mini, width: 300 }, { src: baba1, width: 473 }]}
                    />
                    <PhotoColumn
                        imageSource={baba2}
                        imageTitle="Ali Yakub Babacan"
                        imageSourceList={[{ src: baba2Mini, width: 300 }, { src: baba2, width: 472 }]}
                    />
                </div>

                <div className="photo-center">
                    <PhotoColumn
                        imageSource={babaFoto}
                        imageTitle="Sema Dedesi"
                    />
                </div>
                <article>
                    <p>
                        30 Nisan 1946 yılında Niğde’nin Nar köyünde doğdum. Ailem Kayıboyu aşiretinden gelmektedir. Kayseri’ye yerleşmişlerdir. Burada üç kola ayrılmışlardır. Bir kolu Aksaray Mamasın köyüne göçmüştür.
                        Dedemin de mensub olduğu ikinci kol ise; suyu bol, merası zengin Niğde’de bir yayla köyü olan Nar köyüne yerleşmiştir. Burada hayvancılık ile geçinmişlerdir. Üçüncü kol ise Aydın Söke’ye yerleşmiştir.
                    </p>
                    <p>
                        İlkokula Nar köyünde başladım. Nasıl ki peygamberler çobanlık yapmıştır biz de köydeyken ekseriyet ile çobanlık yapardık.
                        Nar köyünde ilkokulu bitirdim. Daha sonra köyden ayrıldım. Ahmed Saadettin Dedem beni Nevşehir’in Derinkuyu kasabasına götürdü.
                        Orada terzi Halil İbrahim ustanın yanında 9 ay terzilik eğitimi aldım. Derinkuyu kasabasında iken kapı komşumuz muhterem Ali Baba Dede idi.
                        Kendisi soğuk demir ustasıydı. Kendisi son derece yardımsever idi. Yolda kalanlara her zaman yardım ederdi. Aynı zamanda Bektaşi Dedesi idi.
                    </p>
                    <p>
                        Ayrıca, Nevşehir ve Kırşehir bölgesinde Bektaşilik oldukça yaygın idi.
                        Kendisine olan muhabbetimizden ötürü Bektaşi olmak istiyordum. Ancak dedem bana Bektaşi olamazsın derdi.
                        Burada çok aşklı, şevkli zatlar vardı. Kiliseden dönme bir camii vardı. Orada namaz kılardık. Çok feyiz aldık.
                    </p>
                    <p>
                        Dedem son zamanlarda köyde kalmamamı, büyük şehirlere gitmemi öğütlerdi.
                        “İstanbul’a git! Baban, amcan nasılsa buradalar. ‘Çift ile koyun gerisi oyun’, derdi. Sen bu işler ile uğraşma büyük şehirlere, İstanbul’a git”, derdi.
                        Bunu bana defalarca söylerdi. Akrabalarımızdan Hüdaverdi Bey İstanbul’u bilirdi.
                        Zaman zaman gidip gelirdi. Dedem ona derdi ki: “Sen bunu al, İstanbul’a götür uygun bir yere yerleştir.”
                    </p>
                    <p>
                        Daha sonra İstanbul’a geldim. Dedemin bana söylediği adreslerdeki akrabalarımı buldum. Pulcu Ahmed Efendi’yi bulduk.
                        Kendileri bizimle sonuna kadar ilgilendiler. Onun yakınında Ahmediye Camisi’nin (Fatih) yanında üç arkadaş Bozkurt apartmanında bir ev tutuk.
                        Namazlarımızı ekseriyetle Ahmediye Camisi’nde kılardık. Sabah namazlarını İskender Paşa Camisi’nde eda ederdik.
                    </p>

                    <PhotoColumn
                        imageSource={mehmetZahidKotku}
                        imageTitle="Mehmet Zahid Kotku"
                        figcaptionFirstTitle="Mehmet Zahid Kotku (1897-1980)"
                        className="float-left"
                    />
                    <p>
                        Pulcu Ahmed Efendi, “Sıkıldığınız zaman Şeyh Mehmet Zahid Kotku Efendi’nin sohbetlerine gidersiniz.” derdi.
                        1972 yılında İskenderpaşa Camii’nde Mehmet Zahid Kotku Efendi’nin sohbetlerine iştirak ettik.
                        Mehmed Efendinin huzurunda hatme hâce yapardık. Sabah namazlarında hatme hace okunurdu.
                        Kuşluk vaktinde en az iki rekat işrak namazı kılınırdı. Namazdan sonra da kahvaltı ederdik.
                        Ayrıca kendi el yazması olan hatme hâceyi bize hediye etti.
                    </p>
                    <p>
                        Aynı zamanda İstanbul’da bir sanat enstitüsüne yazıldık ve sanat enstitüsünün radyo-elektrik bölümünden mezun olduk.
                        O zamanlar bir Rum arkadaşımla beraber uzunca bir süre cep radyosu yapardık. Hafta sonları yapmış olduğumuz radyoları satardık.
                        Radyoculuktan sonra konfeksiyonda terzilik yaptım. Galatasaray’da iyi bir ustadan terzilik eğitimi aldım.
                        1974 yılına kadar bu şekilde devam ettik.
                    </p>

                    <PhotoColumn
                        imageSource={ibrahimSubasi}
                        imageTitle="Müderris İbrahim Subaşı"
                        figcaptionFirstTitle="Müderris İbrahim Subaşı (1926-2012)"
                        className="float-left"
                    />

                    <p>
                        1974 senesinde çok sevdiğimiz komşumuz Müderris İbrahim Subaşı Efendi, oğlu Hüsrev ve  beraberindeki dört kişi ile cerrahi dergahına gittik.
                        Muzaffer Efendi bizi çok hoş karşıladı. Hoca Efendi ile muhabbeti vardı. Beraberimizdeki bir arkadaş da mana anlattı.
                        Onun dervişliği kabul gördü. Ben de gönlümden derviş olmaya arzu ediyordum.
                        Ancak Muzaffer Efendi, “Mana getirirsen bakarız.” dedi. Bir müddet sonra bana bir mana gösterdiler.
                        Tekkeye gidip ziyarette bulundum. Muzaffer Efendi ile görüşüp elini öptüm. Manayı anlatmaya başladım.
                    </p>

                    <p>
                        “Manada Nisan ayı içerisinde, İstanbul Kıztaşı Fatih semtinde yüksek katlı bir bina gördüm. O binanın içerisine girmemi söylediler.
                        İçeri girdim. Herkese ait numaralandırılmış sandıklar ve çekmeceler vardı. Bana dediler ki: ‘Dosyan 19 numaralı sandıktadır.’
                        Dosyayı aldım elime. O binadan bakınca orada bulunan geniş bir asfalt yol görünüyordu.
                        Oradan bakınca Fatih ,Süleymaniye,  Ayasofya, Sultan Ahmed gibi bütün camileri Allah bana gösteriyordu.
                        Yolun etrafında bahçe şeklinde budanmış ağaçlar vardı. Budanmış ağaçlar ile donatılmış, çok güzel bahçe duvarları vardı.
                        Bu manayı Mürşidim Muzaffer Efendime arz ettim. O da çok tatlı bir tebessüm etti. Safer Muzaffer kolumuza girdiler.
                        Bunu dört kapıdan getirin diye buyurdular. Muzaffer Efendi biatımızı aldılar. Cihazı tarikleri getirdiler. Takke, tesbih, kamerçin tekbirlediler.
                    </p>

                    <p>
                        Daha sonra yatsı namazı eda edildi. Yatsı namazından sonra zikir yapıldı. Kudemadan Derviş Adem Efendi diye bir zat omzuma ve sırtıma post koydu.
                        Zikir icra edildi. Zikirden sonra oturma odasına geçildi. Efendi sohbete başladı.
                        O arada Sefer Efendi, Kemal Baba, Necdet Çelebi, Meydancı Muzaffer efendi, Efendi’nin yanında oturuyorlardı. Efendi mana 19'dan sohbet açtı.
                        Manayı tefsir etmeye başladı. “Benim ismim Süleyman Muzaffer dedi. 19 harften oluşur. Ve Besmele ebced hesabına göre 19 harfdir.
                        Ben de bu tekkenin 19. Şeyhiyim. 19 sene şeyhlik yapacağım dedi. İşte 19’un hikmeti burada anlayana gizlidir. Hayırlı olsun Ali Yakub Efendi” dedi.
                    </p>
                    <div>

                        <PhotoColumn
                            imageSource={MurtazaEfendi}
                            imageTitle="Şeyh Murtaza Efendi"
                            figcaptionFirstTitle="Sohbet Şeyhim"
                            figcaptionSecondTitle="Murtaza Efendi"
                            className="float-left"
                        />
                        <p>
                            Daha sonra sohbet şeyhim olacak Murtaza Efendi ile Muzaffer Efendi’nin sahaflar dükkânında tanıştık.
                            Beyaz Saray Kitaplar Çarşısı’nda İbrahim Subaşı’nın Dersaadet adlı bir kitabevi vardı. Sıklıkla orada buluşurduk.
                        </p>
                        <p>
                            Murtaza Efendi Melami meşrepti. Efendi Hazretleri, Şeyh Murtaza Efendi’ye hizmet etmemi böylelikle onun sohbetinden istifade edeceğimi buyurdular.
                            Muzaffer Efendi: “Bundan sonra Efendi’ye hizmet et, değerli bir ilim adamıdır. Senin onun ilminden faydalanmanı isteriz.” Ben de fırsat buldukça Efendi’ye hizmette bulundum.
                            Koca Mustafa Paşa semtinde Sümbül Efendi Camii civarında saadethanesi bulunur. Zaman zaman orada buluşurduk. Bazen de araba ile gezdirirdik.
                        </p>
                        <p>
                            Çok mükemmel sohbetlerde bulunurdu. Bazen kıraathaneleri giderdi.
                        </p>
                        <p>
                            Murtaza Efendi, kıraathaneye girerken orada bulunan herkes sessizleşir, elindeki oyunu bırakır, dikkatle Murtaza Efendi’nin sohbetini dinlerdi.
                        </p>
                        <p>
                            Bir bayram sabahı Murtaza Efendi bana, "Bugün Cerrahi dergâhına gidelim.” dedi. Muzaffer Efendi ile bayramlaşmak için araba ile dergâha gittik.
                            Dergâh kalabalıktı. Muzaffer Efendi o sırada sohbette bulunuyordu. Efendi’yi rahatsız etmemek için arka tarafta kapının önünde oturdu.
                        </p>
                        <p>
                            Daha evvel İslam olan cemaatten Alman bir hanım vardı. Yanında Alman bir arkadaşını getirmişti. Ve o sırada bu Alman hanım da Müslüman olmak istiyordu.
                            Soruları vardı. Sorularına Muzaffer Efendi cevapladıktan sonra İslam ile müşerref oldu. Kendisine İslamî isim olarak Betül adı verildi.
                            İki hanım tebrikleşip kucaklaştılar. Hem sevindiler hem ağladılar. Çok mutlu olmuşlardı.
                        </p>
                        <p>
                            Bunu gören Murtaza Tunadan Efendi: “Yarın Allah bana huzurunda ‘Dünyada iken ne amel işledin?’ diye sorsa ben de namaz kıldım, oruç tuttum, zekât verdim, hacca gittim diyerek İslam’ın şartlarını söylesem bunlar zaten Allah’a karşı kulluk borcum idi.
                            Ama şu anda görmüş olduğum manzara, Hz. Peygamber (S.A.V)’in huzurunda Müslüman olan müşrikleri bana hatırlattı. Bu bana yeter. Bu manzara benim imanımın şahididir.“ diyerek hüzünlendi.
                        </p>
                        <p>
                            Murtaza Efendi, “İstanbul’un delisi de velisi de eksik olmaz.” derdi. Ardından başından geçen birkaç ilginç olay anlattı. Fatih Camisinin civarında Meczupların kaldığı bir yer vardı.
                            40 gün boyunca Meczuplar ile orada kalmış. Meczuplar, her akşam toplanan yiyecekleri bir kazana doldurup “Nuh Aşı” dedikleri bir yemek yaparlarmış.
                            40 gün orada kaldıktan sonra eve gideceğini onlara söylemiş. Bir hafta evinde kaldıktan sonra Meczuplar onu tekrar çağırmışlar.  Daha sonra bulduğu ilk fırsatta meczuplarla kaldığı yerden ayrılmış.
                        </p>
                        <p>
                            Bir süre sonra da İstanbul’dan ayrılıp Ankara’ya gitmiş. Orada iken ayakkabı tamirciliği yapmış. Eski ayakkabıları tamir edermiş. Bir gün iki genç hanım ayakkabılarını tamir ettirmek için Efendi’nin yanına gelmiş.
                            O gün de kandil günüymüş. Bu genç hanımlar, “Bugün kandil günü olduğu için çalışmıyoruz. Sizleri de evimize davet etmek istiyoruz.” demişler.
                            Efendi de tekliflerini kabul etmiş. Evlerine gitmiş. Başta iki hanım iken daha sonra on-on beş hanım daha çıka gelmiş. Ev kalabalıklaşmış.
                            Yemek yedikten sonra gece orada mecburen kalmış. Gece olunca namaz kılmak için seccade istemiş. Evdekiler buranın umumhane olduğunu söylemişler.
                            Murtaza Efendi bunu duyunca pişman olmuş. Buraya nasıl, ne zaman geldiğini anlayamamış. Daha sonra sabah ezanına kadar oradaki hanımlar ile sohbette bulunmuş.
                            Sabah olunca da camiye gitmiş. Daha sonra bu hanımlar devamlı surette ona ayakkabılarını tamir ettirmeye getirirlermiş. Murtaza Efendi, bu hanımlardan 3 kişiyi evlendirmiş.
                            Bir gün evlendirdiği hanımlardan birisini markette görmüş. Hanım, hamile imiş. Efendi de utandırmamak için oradan ayrılmış ve İstanbul’a geri dönmüş.
                        </p>
                        <p>
                            Bir gün Fatih Camiin’de Murtaza Efendi ile karşılaştık. Elinde zembil çantası vardı. “Pazara geçelim mi?” dedi. Beraber pazara gittik. O zaman da bir Ramazan günü idi. Pazardan sağdan soldan “Buyrun, buyrun” diye çağırıyorlardı.
                            Oradaki bir tezgâhın yanına vardık. Ramazan ayı olmasına rağmen tezgâh sahipleri sofra kurmuş, yemek yiyorlardı. Efendi yanlarına vardı. Tezgâhlardan bir şeyler almak istedi. Oradan alışveriş yaptı.
                            Karşı tezgâhlardaki esnaflar ise Efendi’ye kızmaya başladılar. Efendi onlara selam verdi. Selamını almak istemediler. Efendi: “Evladım, haklısınız siz şeriatın polisisiniz. Yapmanız gerekeni yapıyorsunuz.
                            Sağolun evladım. Fakat biz de cebimizdeki paranın helâl olduğunu biliyoruz. Bildiğimiz için de onların kursağına bu helal para girsin de inşallah oruç tutarlar diye dua ettik.”
                            Bir hafta sonra fakir oraya tekrar gitti. Esnaflar, Efendi’yi sordular. Ben de “Efendi, Sümbül Efendi’de oturduğu için her zaman buraya gelemiyor.” dedim. O esnaflar da “Efendi’nin duası ile biz de oruca başladık.” dediler.
                        </p>
                        <p>
                            Bir gün yine Murtaza Efendi hoş bir sohbette bulunurken İbrahim Subaşı için “Bunlar Molladır, Müdderisindir. Tasavvuf ehli değildir. Tasavvuf neşvesinde değildir. Bunu bilmiş ol.” diyerek Hoca Efendi’ye gülümsedi.
                        </p>
                        <p>
                            İbrahim Subaşı da Efendim “İnşallah sizlerin ilminden istifade ederiz. Dua buyurun.” diye niyazda bulundu.
                        </p>
                        <p>
                            Başka bir gün İbrahim Subaşı Hırka-i Şerif’deki evine Murtaza Efendi ile Fakiri de davet etti. Evin de kütüphanesinde buluştuk. Hoca Efendi’nin Murtaza Efendi’ye çok muhabbeti vardı. O sırada Mevlevi Şeyhi Hasan Efendi de geldiler.
                        </p>
                        <p>
                            Hasan Efendi bizim iş yerinden komşumuzdu. Kendisi ile çok iyi tanışıktık.
                        </p>
                        <p>
                            Murtaza Efendi: “Yakub Efendi sana bir hikâye anlatayım mı?”
                        </p>
                        <p>
                            Ben de “Buyurun, Efendim.” dedim.
                        </p>
                        <p>
                            Murtaza Efendi: “Bir zat Galata köprüsünün başında erkenden dururmuş. Buradan ilk geçen zat benim şeyhim olacak dermiş.
                            Ayakta zor duran serhoş bir adamı görür görmez yakasından tutmuş: ‘Sen benim şeyhim olacaksın.’ demiş.
                            Adam: ‘Bırak beni.’ O da ‘Bırakmam seni. Benim şeyhim olacaksın.’ demiş. Ve ısrarında devam etmiş.
                            Serhoş adam da bu zatın elinden kurtuluş yolu olmadığını anlamış. Sonra Allah ona ilham etmiş. Serhoş adam da bu zata demiş ki: “Ben bu işe mezun değilim. Bana yardımcı ol sana hizmet edeyim.”
                            Bunu söyledikten sonra serhoş adam kendisine gelmiş. Tövbe etmiş. Bu vesile ile de doğru yolu bulmuş.
                        </p>
                        <p>
                            Başka bir gün de sohbet şeyhim Fakiri davet buyurdular. Evlerine gittik. Görüştük. Bunun üzerine daha da samimileştik.
                        </p>
                        <p>
                            1980 senesinde sohbet şeyhimin şehitlikteki kabrini ziyarete gitmiştim. Kabrin kenarında oturup dua okuyordum. Bir ses duydum. Etrafımda bir kalabalık beliriverdi.
                            Kalabalık cemaat zikir yapmaya başladı. Sultan Abdulkadir Geylani Hazretlerinin Bağdat’daki Dergâhının Şeyhi Osmanlı Paşa Baba, halifesi ve 18 kişiden oluşan bir cemaati ile beraber kabri ziyarete gelmişlerdi.
                            Daha sonra kaldıkları İstanbul’da Bağdat Caddesindeki zaviyeye bizi davet ettiler. Orada sohbette bulunduk. Şeyh Efendi bizden “Abdülkadir Efendimizden bir isteğiniz var mıdır?”.
                            Fakir de “Efendim Allah razı olsun. Sizin ilminizden istifade etmeye çalışıyoruz inşallah.” dedim.
                            Daha sonra Muzaffer Efendi Amerika’daki seyahatinden döndükten sonra konu hakkında bana sual etti: “Paşa Baba, buraya ayağına kadar gelmiş. ‘Sultan Abdülkadir Efendimiz Şeyhi takdir sizindir.’ diyecektiniz. Allah iyiliğini versin.”
                        </p>
                        <h3 className="auto-title">MUZAFFER AŞKÎ İLE <br/> ALİ YAKUB BABA'NIN HİLAFET MERASİMİ</h3>
                        <PhotoColumn
                            imageSource={hilafetMerasimiHuzurda}
                            imageTitle=""
                        />
                        <PhotoColumn
                            imageSource={hilafetMerasimi}
                            imageTitle=""
                        />
                        <PhotoColumn
                            imageSource={semazenbasiSikkeMerasami}
                            imageTitle="Selman Dede Yakub Baba'ya Sikke Tekbirlerken"
                            figcaptionFirstTitle="Selman Dede Yakub Baba'ya Sikke Tekbirlerken"
                        />
                        <PhotoColumn
                            imageSource={babaTaciSerifNiyaz}
                            imageTitle=""
                        />
                        <PhotoColumn
                            imageSource={hzPireNiyaz}
                            imageTitle="Hz. Pire Niyaz Ederken"
                            figcaptionFirstTitle="Hz. Pire Niyaz Ederken"
                        />
                    </div>
                </article>
            </section>
        );
    }
}

export default Autobiography;